import {
  EN_STANDARD_BRANCH_NAMESPACE,
  IContainerInstance,
  IContainerRegisterInstanceParams,
  ISymbol,
} from '../types/interface';

/**
 * 由于ioc库inversify需要使用的reflect-metadata和当前版本的mobx存在冲突
 * 所以只能自己写了
 * 主要是实现了container，其他功能目前没发现使用场景
 *
 * 设计思路如下:
 * 所有品系定制化资源根据namespace拆分为大的仓库后
 * 再由symbol决定此资源的具体类型
 * 例: 导入树节点的一个定制化资源namespace为EN_STANDARD_BRANCH_NAMESPACE.SERVICE_PLUGIN, symbol为EN_SERVICE_PLUGIN_SYMBOL.IMPORT_NODE
 */
export class StandardBranchContainerImpl {
  private _map = new Map<EN_STANDARD_BRANCH_NAMESPACE, IContainerInstance[]>();

  public register(params: IContainerRegisterInstanceParams): void {
    const { namespace, symbol, description = '', value } = params;
    const instance = {
      description,
      value,
      symbol,
    } as IContainerInstance;

    const namespaceArr = this._map.get(namespace);
    if (!namespaceArr) {
      this._map.set(namespace, [instance]);
    } else {
      namespaceArr.push(instance);
    }
  }

  public unRegister(namespace: EN_STANDARD_BRANCH_NAMESPACE, symbol?: ISymbol): void {
    const elements = this._map.get(namespace);
    if (!elements) {
      return;
    }
    if (symbol) {
      const newElements = elements.filter((ele) => ele.symbol !== symbol);
      this._map.set(namespace, newElements);
    } else {
      this._map.delete(namespace);
    }
  }

  public get(namespace: EN_STANDARD_BRANCH_NAMESPACE): IContainerInstance | undefined {
    return this.getAll(namespace).at(-1);
  }

  public getAll(namespace: EN_STANDARD_BRANCH_NAMESPACE): IContainerInstance[] {
    return this._map.get(namespace) ?? [];
  }

  public getSymbolized(
    namespace: EN_STANDARD_BRANCH_NAMESPACE,
    symbol?: ISymbol
  ): IContainerInstance | undefined {
    return this.getAllSymbolized(namespace, symbol).at(-1);
  }

  public getAllSymbolized(
    namespace: EN_STANDARD_BRANCH_NAMESPACE,
    symbol?: ISymbol
  ): IContainerInstance[] {
    return this.getAll(namespace).filter((instance) => instance.symbol === symbol);
  }

  public isBound(namespace: EN_STANDARD_BRANCH_NAMESPACE, symbol?: ISymbol): boolean {
    if (symbol) {
      return !!this.getSymbolized(namespace, symbol);
    }

    return !!this.get(namespace);
  }

  public clear(): void {
    this._map.delete(EN_STANDARD_BRANCH_NAMESPACE.SERVICE_PLUGIN);
    this._map.delete(EN_STANDARD_BRANCH_NAMESPACE.UI_PLUGIN);
  }
}
